import type { Slice } from 'prosemirror-model';
import { TextSelection } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';

function sliceSingleNode(slice: Slice) {
  return slice.openStart === 0 && slice.openEnd === 0 && slice.content.childCount === 1
    ? slice.content.firstChild
    : null;
}

// based on prosemirror-view doPaste; modifications were needed to handle pasting text blocks (headings, quotes)
export const handlePaste = (view: EditorView, event: ClipboardEvent, slice: Slice) => {
  if (!slice) return false;

  const singleNode = sliceSingleNode(slice);
  const { selection, tr } = view.state;

  if (singleNode) {
    tr.replaceSelectionWith(
      singleNode,
      (<EditorView & { input: { shiftKey: boolean } }>view).input.shiftKey,
    );
  } else if (selection instanceof TextSelection) {
    if (selection.empty) {
      // empty selection = cursor
      // insert will split blocks if necessary
      const insertAt = selection.$from.parentOffset === 0 ? selection.from - 1 : selection.from;
      tr.insert(insertAt, slice.content);
    } else {
      // some text is selected; delete+insert properly splits blocks, preserving pasted node types
      tr.delete(selection.from, selection.to);
      tr.insert(selection.from, slice.content);
    }
  } else {
    // it's a NodeSelection
    // default transaction works as expected
    tr.replaceSelection(slice);
  }

  view.dispatch(tr.scrollIntoView().setMeta('paste', true).setMeta('uiEvent', 'paste'));
  return true;
};
